import Show from "common/js/component/Show.vue";

import Widget from "common/js/component/widget/Widget.vue";
import WidgetContentImage from "common/js/component/widget/WidgetContentImage.vue";
import WidgetContentLogo from "common/js/component/widget/WidgetContentLogo.vue";
import WidgetContentProduct from "common/js/component/widget/WidgetContentProduct.vue";
import WidgetContentProductList from "common/js/component/widget/WidgetContentProductList.vue";
import WidgetContentPromotion from "common/js/component/widget/WidgetContentPromotion.vue";
import WidgetContentText from "common/js/component/widget/WidgetContentText.vue";
import WidgetContentTicker from "common/js/component/widget/WidgetContentTicker.vue";
import WidgetContentVideo from "common/js/component/widget/WidgetContentVideo.vue";

export default function(app){

    app.component(Show.name, Show);

    app.component(Widget.name, Widget);
    app.component(WidgetContentImage.name, WidgetContentImage);
    app.component(WidgetContentLogo.name, WidgetContentLogo);
    app.component(WidgetContentProduct.name, WidgetContentProduct);
    app.component(WidgetContentProductList.name, WidgetContentProductList);
    app.component(WidgetContentPromotion.name, WidgetContentPromotion);
    app.component(WidgetContentText.name, WidgetContentText);
    app.component(WidgetContentTicker.name, WidgetContentTicker);
    app.component(WidgetContentVideo.name, WidgetContentVideo);
}